export enum LiveClassModeEnum {
  ONLINE = 1,
  HYBRID = 2,
  OFFLINE = 3,
}

export enum MeetingPlatformEnum {
  ZOOM = 1,
  BBB = 2,
}

export enum LiveClassFrequencyEnum {
  ONE_TIME = 1,
  RECURRING = 2,
}

export enum LiveClassCategoryEnum {
  SCHEDULED = 1,
  ACTIVE = 2,
  COMPLETED = 5,
  CANCELLED = 6,
}

export enum StudentLiveClassCategoryEnum {
  SCHEDULED = 1,
  ACTIVE = 2,
  COMPLETED = 5,
}

export enum LiveClassStatusEnum {
  SCHEDULED = 1,
  STARTED = 2,
  COMPLETED = 3,
  COMPLETED_BY_SUBSTITUTE = 4,
  RESCHEDULED = 5,
  CANCELLED = 6,
  AUTO_CANCELLED = 7,
  AUTO_ENDED = 8,
}

export enum LiveClassCompletionStatusEnum {
  COMPLETED = 3,
  COMPLETED_BY_SUBSTITUTE = 4,
  CANCELLED = 6,
}

export enum MeetingRecordingStatusEnum {
  PENDING = 1,
  PROCESSING = 2,
  READY = 3,
  UNAVAILABLE = 4,
  FAILED = 5,
  COMPLETED = 6,
}
